import { useTheme } from "@mui/material";

const BcbsMnLogo = () => {
  const theme = useTheme();
  const light = theme.palette.primary.light;

  return (
    <svg
      style={{ margin: "20px 0 0 0" }}
      // width={"8rem"}
      height="3rem"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 124.925 42"
    >
      <defs>
        <clipPath id="clip-path">
          <rect id="Rectangle_1887" data-name="Rectangle 1887" width="90" height="26.9" />
        </clipPath>
      </defs>
      <g id="Group_884" data-name="Group 884">
        <g id="Group_870" data-name="Group 870" clipPath="url(#clip-path)">
          <path
            id="Path_491"
            data-name="Path 491"
            d="M41.3,24.8a18.139,18.139,0,0,1-4.4-3.9,22.886,
                            22.886,0,0,1-3.5-6.6c-1.4-4.1-1.5-8.4-.2-11.6l.1-.3.3.1A23.1,23.1,0,0,0,
                            38,3.6c.9.1,1.6.2,2.4.3h2a9.863,9.863,0,0,0,2.4-.3,27.4,27.4,0,0,0,
                            4.4-1.1l.3-.1.1.3c1.3,3.1,1.2,7.5-.2,11.6a20.692,20.692,0,0,1-3.5,6.6,
                            16.263,16.263,0,0,1-4.4,3.9l-.2.1Z"
            fill="#fff"
          />
        </g>
        <g id="Group_871" data-name="Group 871" clipPath="url(#clip-path)">
          <path
            id="Path_492"
            data-name="Path 492"
            d="M13.4,21A7.6,7.6,0,1,1,21,13.4,7.6,7.6,0,0,1,13.4,21"
            fill="#fff"
          />
        </g>
        <g id="Group_872" data-name="Group 872" clipPath="url(#clip-path)">
          <path
            id="Path_493"
            data-name="Path 493"
            d="M11.6,7.3a5.2,5.2,0,0,0-3,2h3.3c.1,0,.1-.1,0-.2a1.476,1.476,0,0,1-.3-1.8"
            fill={light}
          />
        </g>
        <g id="Group_873" data-name="Group 873" clipPath="url(#clip-path)">
          <path
            id="Path_494"
            data-name="Path 494"
            d="M13.4,15.3a.1.1,0,0,0-.1.1l-2.5,3.8a5.753,5.753,0,0,0,2.6.5,7.512,7.512,0,0,0,2.6-.5l-2.5-3.8a.1.1,0,0,1-.1-.1"
            fill={light}
          />
        </g>
        <g id="Group_874" data-name="Group 874" clipPath="url(#clip-path)">
          <path
            id="Path_495"
            data-name="Path 495"
            d="M11,12.2l-3.7-.3a7.719,7.719,0,0,0-.2,1.5,6.433,6.433,0,0,0,1.5,4.1l2.6-5c.1-.1,0-.2-.2-.3"
            fill={light}
          />
        </g>
        <g id="Group_875" data-name="Group 875" clipPath="url(#clip-path)">
          <path
            id="Path_496"
            data-name="Path 496"
            d="M15.8,12.2c-.3,0-.3.1-.2.3l2.6,5a5.925,5.925,0,0,0,1.5-4.1,7.719,7.719,0,0,0-.2-1.5Z"
            fill={light}
          />
        </g>
        <g id="Group_876" data-name="Group 876" clipPath="url(#clip-path)">
          <path
            id="Path_497"
            data-name="Path 497"
            d="M17.9,19.2h0l-3.4-6.3a1.158,1.158,0,0,1,.8-1.6l4.9-.5h0a7.512,7.512,0,0,1,.5,2.6,7.553,7.553,0,0,
                            1-2.8,5.8m-.5.3h0a6.979,6.979,0,0,1-4,1.2,6.758,6.758,0,0,1-4-1.2h0L13,
                            14.2a.516.516,0,0,1,.9,0l3.5,5.3ZM6,13.4a7.512,7.512,0,0,1,.5-2.6h0l4.9.5c.9.1,1,1,
                            .8,1.6L8.8,19.2h0A7.553,7.553,0,0,1,6,13.4m7.4-7.3a7.465,7.465,0,0,1,6.7,
                            4.2H14.9a1.032,1.032,0,0,1-1.1-.8,1.1,1.1,0,0,1,.4-1A1.024,1.024,0,0,0,13.4,7a.917.917,
                            0,0,0-.7,1.5c.3.5.4.6.4,1s-.3.8-1.1.8H6.8a7.1,7.1,0,0,1,6.6-4.2m5.9,
                            1.3V0H7.4V7.4H0V19.3H7.4v7.4H19.2V19.3h7.4V7.4Z"
            fill={light}
          />
        </g>
        <g id="Group_877" data-name="Group 877" clipPath="url(#clip-path)">
          <path
            id="Path_498"
            data-name="Path 498"
            d="M14.9,9.3h3.3a6.912,6.912,0,0,0-3-2,1.5,1.5,0,0,1-.3,1.8c-.1.1-.1.2,0,.2"
            fill={light}
          />
        </g>
        <g id="Group_878" data-name="Group 878" clipPath="url(#clip-path)">
          <path
            id="Path_499"
            data-name="Path 499"
            d="M49.2,14.2c-1.4,4.1-3.6,7.8-7.8,10.4h0c-4.1-2.6-6.3-6.2-7.8-10.4-1.3-3.7-1.6-8-.2-11.4a27.4,
                            27.4,0,0,0,4.4,1.1,16.866,16.866,0,0,0,3.5.3h0A34.135,34.135,0,0,0,45,4a27.4,27.4,0,0,0,
                            4.4-1.1c1.4,3.3,1,7.6-.2,11.3M50.5,0a20.038,20.038,0,0,1-9.1,2.2A18.918,18.918,0,0,1,
                            32.3-.1c-1.9,3.7-2.2,9.7-.6,14.8a20.567,20.567,0,0,0,9.7,12.1,20.945,20.945,0,0,0,
                            9.7-12.1c1.6-4.9,1.3-11-.6-14.7"
            fill={light}
          />
        </g>
        <g id="Group_879" data-name="Group 879" clipPath="url(#clip-path)">
          <path id="Path_500" data-name="Path 500" d="M41.5,23.7Z" fill="#00afea" />
        </g>
        <g id="Group_880" data-name="Group 880" clipPath="url(#clip-path)">
          <path
            id="Path_501"
            data-name="Path 501"
            d="M44.4,7.7a.769.769,0,0,1-.2.3,8.12,8.12,0,0,0-1,.9c-.2.2-.5.4-.6.6a.349.349,
                            0,0,1-.1.2c-.6-.1-1.3-.1-1.7-.2V9s.6,0,.7-.4a.31.31,0,0,0-.1-.2.494.494,0,0,
                            0-.3-.1,3.942,3.942,0,0,1,1.4.5c0-.1-.1-.2-.1-.3a.769.769,0,0,0-.3-.2,8.376,8.376,0,0,
                            0-1-.2h.6A1.007,1.007,0,0,0,42,8a.367.367,0,0,0-.1-.3l-.2-.2c-.1-.1-.2-.3-.3-.4a2.877,2.877,
                            0,0,0-.6-.4V6.2a.6.6,0,0,1,.4-.1,6.117,6.117,0,0,0,1.2.5c.1.1.1.1.1.2.1.3-.1.8,0,
                            1,0,.1.1.1.2,0A12.487,12.487,0,0,1,43.9,7s.6.3.5.7m-2,6.1s.1-.9.1-1.4a.365.365,0,0,
                            0,.2-.5c0-.1-.2-.2-.3-.2a7.719,7.719,0,0,0-1.5-.2,5.853,5.853,0,0,1-1.3-.2,2.7,2.7,
                            0,0,1-2-1.4,2.1,2.1,0,0,1,.9-2.7,2.648,2.648,0,0,1,2.3,0,.821.821,0,0,1,
                            .5.5c.1.1.2.1.2.2s0,.1-.1.1H39.7c.2.1.5.3.7.4.1.1.2.1.4.1a.349.349,0,0,1,
                            .2.1c0,.1-.1.1-.2.1a.854.854,0,0,1-.7,0c-.4-.1-.6-.3-.9-.2a.471.471,0,0,0-.1.6c.1.4.5.5.8.6,
                            1.1.4,2.3.2,3.4.7a2.132,2.132,0,0,1,1,1.1c.4,2.1-1.9,2.3-1.9,2.3m-1.7-2a5.951,5.951,0,0,
                            1,.8.1,2.442,2.442,0,0,1,.7.1l-.1,2c-.4-.1-.7-.1-1.1-.2a3.387,3.387,0,0,0-.6-1.5.139.139,
                            0,0,1,0-.2c0-.1.3-.1.3-.1Zm3,4.4a1.555,1.555,0,0,1-.6.8,1.727,1.727,0,0,1-.7.2V16.1a.1.1,
                            0,0,0,.1-.1c.1-.1.1-.1.1-.2s-.1-.1-.2-.2a1.007,1.007,0,0,
                            1-.3-.1c-.5-.1-1-.1-1.6-.2-.9-.2-1.6-.7-1.6-1.6,0-.6.7-.8,1.1-1,.1.3.3.5.3.7a1,1,0,0,1,
                            .1.4.2.2,0,0,0-.2.2c0,.1.2.2.3.2a10.084,10.084,0,0,1,2,.4,2.177,2.177,0,0,1,.8.5,1.05,
                            1.05,0,0,1,.4,1.1m-2.6-.4a3.4,3.4,0,0,0,1,.1v1.8l-.4-.2-.4-.2ZM42.7,20a1.463,1.463,0,0,
                            1-.5.3v-.8a.349.349,0,0,0,.1-.2c0-.2-.6-.5-.9-.6a4.179,4.179,0,0,1-1-.4,1.031,1.031,0,0,
                            1-.6-1.5c.1-.2.4-.4.5-.5l.4-.2.1.9a.1.1,0,0,0-.1.1c0,.2.1.2.1.3a10.092,10.092,0,0,1,
                            1.5.7c.6.3.8.6.8,1a.963.963,0,0,1-.4.9m-.8,2a.319.319,0,0,1-.3.3.265.265,0,0,1-.3-.3c0-1-.1-3-.1-3a1.425,
                            1.425,0,0,1,.4.2.747.747,0,0,1,.3.3v.1c0,.7,0,2.1,0,2.4m-1.2-.9c0,.3.1.4,
                            0,.5,0,.2-.2.1-.3,0a1.072,1.072,0,0,1-.2-.6,1.556,1.556,0,0,1,.3-.9l.2-.2v.8c.2.1.1.2,
                            0,.4M45,4.9a21.863,21.863,0,0,1-3.6.3h0a21.862,21.862,0,0,1-3.6-.3,23.254,23.254,0,0,
                            1-3.6-.8,14.99,14.99,0,0,0,0,8.4c1.3,5.3,4.4,9.3,7.2,11a18.388,18.388,0,0,0,7.2-11,14.99,
                            14.99,0,0,0,0-8.4,15.532,15.532,0,0,1-3.6.8"
            fill={light}
          />
        </g>
        <g id="Group_881" data-name="Group 881" clipPath="url(#clip-path)">
          <path
            id="Path_502"
            data-name="Path 502"
            d="M40.1,7.3c.1.1.1.3.3.2.1,0,.2-.1.3-.1h.1c-.2-.2-.7-.2-1-.2.1.1.2,0,.3.1"
            fill={light}
          />
        </g>
        <g id="Group_882" data-name="Group 882" clipPath="url(#clip-path)">
          <path
            id="Path_503"
            data-name="Path 503"
            d="M50.3,25.3h.3c.2,0,.5,0,.5-.3,0-.2-.2-.3-.4-.3h-.4v.6Zm-.3-.8h.7c.4,0,
                            .6.2.6.5s-.2.4-.5.5l.5.8H51l-.5-.7h-.3v.7H50Zm.6,2.2a1.3,1.3,0,0,0,0-2.6,
                            1.184,1.184,0,0,0-1.2,1.3,1.24,1.24,0,0,0,1.2,1.3m0-2.8a1.5,1.5,0,1,1-1.5,
                            1.5,1.473,1.473,0,0,1,1.5-1.5"
            fill={light}
          />
        </g>
        <g id="Group_883" data-name="Group 883" clipPath="url(#clip-path)">
          <path
            id="Path_504"
            data-name="Path 504"
            d="M24.9,25.3h.3c.2,0,.5,0,.5-.3,0-.2-.2-.3-.4-.3h-.4Zm-.3-.8h.7c.4,0,
                            .6.2.6.5s-.2.4-.5.5l.5.8h-.3l-.5-.7h-.3v.7h-.3V24.5Zm.6,2.1a1.184,1.184,0,
                            0,0,1.2-1.3,1.2,1.2,0,1,0-2.4,0,1.184,1.184,0,0,0,1.2,1.3m0-2.7a1.5,1.5,0,
                            1,1-1.5,1.5,1.473,1.473,0,0,1,1.5-1.5"
            fill={light}
          />
        </g>
      </g>
      <rect
        id="Rectangle_1901"
        data-name="Rectangle 1901"
        width="0.5"
        height="26.6"
        transform="translate(59.8 0.1)"
        fill={light}
      />
      <path
        id="Path_505"
        data-name="Path 505"
        d="M68,19.3V7.5h3.1l2.3,8.3h0l2.3-8.3h3.2V19.3H77V10h-.1l-2.6,9.3H72.6L70,10h-.1v9.3Z"
        fill={light}
      />
      <path
        id="Path_506"
        data-name="Path 506"
        d="M87.9,7.5v8.1h-.1L83.2,7.5H80.8V19.3H83V10.9h0l4.8,8.4H90V7.5Z"
        fill={light}
      />
    </svg>
  );
};

export default BcbsMnLogo;
